import { AnalyticsEvents, useAnalytics } from "@next-platform/client-common-core";
import { useCallback, useRef } from "react";

import AnalyticsProvider from "@/utils/analyticsProvider";

const useQueueLogEvent = () => {
  const { logEvent: logger } = useAnalytics();
  const refLogger = useRef(logger);
  refLogger.current = logger;

  const logEvent = useCallback((eventName: AnalyticsEvents, eventData: object) => {
    if (!AnalyticsProvider.isInitialized()) {
      AnalyticsProvider.queueEvent(eventName, eventData);
    } else {
      refLogger.current(eventName, eventData);
    }
  }, []);

  return { logEvent };
};

export default useQueueLogEvent;
